var _g, _rect, _rect2, _rect3, _path, _text, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHsaFsaCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 84",
    role: "img",
    "aria-label": "HSA and FSA cards",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12 42 34)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 72,
    height: 46,
    rx: 7,
    fill: "#2F6FE4",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 40c-6-4.5-9-7.5-9-11a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 3.5-3 6.5-9 11z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12,31 17,31 19.5,27 23,35 25.5,31 32,31",
    fill: "none",
    stroke: "#2F6FE4",
    strokeWidth: 1.8,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 30,
    textAnchor: "end",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "FSA"), /*#__PURE__*/React.createElement("path", {
    d: "M14 50h10M30 50h10",
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 74,
    height: 48,
    rx: 7,
    fill: "#301A38",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 38,
    width: 12,
    height: 4,
    rx: 1.2,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 43.5,
    width: 14,
    height: 17,
    rx: 2.5,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 47.5v9M53.5 52h9",
    stroke: "#301A38",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 52,
    textAnchor: "end",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "HSA")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70h9M67 70h9M82 70h9M97 70h9",
    stroke: "#4CC38A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsaFsaCards);
export default __webpack_public_path__ + "static/media/hsa-fsa-cards.c8b40435abc53678655ddf6fce275594.svg";
export { ForwardRef as ReactComponent };